import axios from 'axios';

const STRAPI_URL = import.meta.env.VITE_STRAPI_URL || 'http://localhost:1337';

export const API = axios.create({
  baseURL: `${STRAPI_URL}/api`,
  withCredentials: true,
});

export const attachLoadingInterceptors = (startLoading, stopLoading) => {
  API.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    startLoading();
    return config;
  });

  API.interceptors.response.use(
    (res) => {
      stopLoading();
      return res;
    },
    (error) => {
      stopLoading();
      return Promise.reject(error);
    }
  );
};
